<template>
  <div class="page noselect">


    <div v-if="!ready">
      <div class="spacer-25"></div>
      <v-skeleton-loader
        class="mx-auto"
        max-width="600"
        type="card"
      ></v-skeleton-loader>
    </div>
    <!--        <h2 v-if="!ready" class="myTitle">Lade Bestellung...</h2>-->

    <v-container grid-list-md v-if="ready">
      <!--        <h1 class="myTitle mobile">Bestellung <br>#{{order.orderNumber}}</h1>-->
      <!--            <h2 class="myTitle">Bestellung #{{order.orderNumber}}</h2>-->

      <!--            <div class="ma-5">-->
      <!--                <v-btn class="btn-df"-->
      <!--                       @click="debugNotification"-->
      <!--                >DEBUG Notification-->
      <!--                </v-btn>-->
      <!--            </div>-->

      <!--      <div>DEBUG usecase {{order.usecase}}</div>-->

      <!--      <div>DEBUG posOrderStatus: {{ order.posOrderStatus }}</div>-->
      <!--      <div>DEBUG selfServiceEnabled: {{ $store.getters.selfServiceEnabled }}</div>-->
      <!--      <div>DEBUG waitingForAbholbereit: {{ waitingForAbholbereit }}</div>-->
      <!--      <div>DEBUG waitingForGetraenkeAbholbereit: {{ waitingForGetraenkeAbholbereit }}</div>-->
      <!--      <div>DEBUG isTakeawayForNow: {{ isTakeawayForNow }}</div>-->
      <!--      <div v-if="order.posPickupInfo">DEBUG posPickupInfo: {{ JSON.stringify(order.posPickupInfo) }}</div>-->
      <!--      <div v-if="order.posDeliveryInfo">DEBUG posDeliveryInfo: {{ JSON.stringify(order.posDeliveryInfo) }}</div>-->

      <div v-if="order.stornoAmounts && order.stornoAmounts.length > 0" class="mt-5 mb-5">
        <div class="pa-3" style="background-color: #333333; color:#DDDD00">
          <div>Bereits stornierte Artikel:</div>
          <div v-for="sa in order.stornoAmounts" class="mt-2">
            <div class="d-flex">
              <div class="pr-3">-{{ sa.countRemoved }} x {{ sa.name }}</div>
              <div class="flex-grow-1 text-right">{{ sa.amountRemoved | price }}</div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="order.storno"
        class="pickupHint text-center">
        <h3 class="mt-4">Die Bestellung wurde storniert</h3>
        <div><b>Bestellnummer: #{{ order.orderNumber }}</b></div>
        <div v-if="order.userInfo && order.userInfo.name"><b>Name: {{ order.userInfo.name }}</b></div>
        <div>Zahlung: storniert</div>
        <div class="spacer-25"></div>
        <ItemDetails :order="order"></ItemDetails>
        <div class="mt-5" v-if="order.note && order.note.length > 0">
          <div>Hinweis: {{ order.note }}</div>
        </div>
      </div>

      <div v-else>
        <div class="pickupHint text-center" :style="{'opacity': order.sentToPos?'1':'0.8'}"
             v-if="(order.usecase === 'takeAway' || order.usecase === 'delivery' || order.usecase === 'digital')">

          <!--                <div class="text-center pt-5 mb-5">-->
          <!--                    <h2 v-if="order.sentToPos">Bestellung erfolgreich übermittelt</h2>-->
          <!--                    <h2 v-else class="colorPulsing">Bestellung wird übermittelt...</h2>-->
          <!--                </div>-->
          <!--                    <div>DEBUG: isTakeawayForNow={{!!isTakeawayForNow}}</div>-->
          <!--                    <div>DEBUG: usecase={{order.usecase}}</div>-->
          <!--                    <div>-->
          <!--                        <v-btn @click="debugNow">isTakeawayForNow</v-btn>-->
          <!--                    </div>-->
          <!--                    <div>DEBUG: targetTime={{order.targetTime | dateToString}}</div>-->
          <!--                    <div v-if="order.usecase === 'takeAway' && $store.getters.selfServiceEnabled && !order.abholbereit && isTakeawayForNow"-->
          <!--                         style="color: yellow; background-color: black; opacity: 0.8"-->
          <!--                         class="mt-4 pa-4 mb-4 hinweisBlink">-->
          <!--                        {{hh}}-->
          <!--                    </div>-->
          <div class="text-center pt-5 mb-5">
            <div class="icon icon--order-success svg"
                 v-if="(!$store.getters.selfServiceEnabled || order.usecase === 'delivery' || order.usecase === 'takeAway' || order.usecase === 'digital') && (!withPosApi || order.sentToPos)">
              <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
                <circle stroke="#50A92F" stroke-width="2" cx="36" cy="36" r="34" fill="none"/>
                <path fill-rule="evenodd" clip-rule="evenodd" fill="#50A92F"
                      d="M52.5 21.4c-.9-.6-2.1-.5-2.8.2l-20.7 20.2-4.7-5.1c-.8-.8-2.4-1.2-3.5-.5-1.1.9-1.2 2.3-.5 3.5 0 0 5.1 8.7 5.7 9.7s1.6 1.6 3 1.6c1.1 0 2-.6 2.9-1.6.7-.8 20.8-25.3 20.8-25.3.6-.7.6-2-.2-2.7z"></path>
              </svg>
            </div>
          </div>

          <div style="margin: 15px 0" class="confirmed">

            <div v-if="order.usecase === 'takeAway' || order.usecase === 'digital'">

              <div v-if="$store.getters.selfServiceEnabled && isTakeawayForNow">
                <h3>Summe: {{ order.paymentInfo.amount | price }}</h3>
                <h3>Bestell-Nr: {{ order.orderNumber }}</h3>
                <div class="text-center" v-if="order.usecase !== 'digital'">
                  <div class="text-left d-inline-block mt-2">
                    <!--                    <div v-if="withPosApi && !order.sentToPos" class="mt-2 mb-2">-->
                    <!--                      <WaitingForPos></WaitingForPos>-->
                    <!--                    </div>-->
                    <div><b>
                      <v-icon class="iconOk" medium>mdi-check-bold</v-icon>&nbsp;Bestellung
                      übermittelt</b>
                    </div>
                    <div v-if="hasGetraenke()"><b>
                      <v-icon
                        v-if="order.getraenkeAbholbereit"
                        class="iconOk" medium>mdi-check-bold
                      </v-icon>
                      <v-icon v-else class="iconNotOk" medium>mdi-close-thick</v-icon>&nbsp;
                      Getränke abholbereit</b>
                    </div>
                    <div v-if="hasSpeisen()"><b>
                      <v-icon
                        v-if="order.abholbereit"
                        class="iconOk" medium>mdi-check-bold
                      </v-icon>
                      <v-icon v-else class="iconNotOk" medium>mdi-close-thick</v-icon>&nbsp;
                      Speisen abholbereit</b>
                    </div>
                  </div>
                  <!--                                    <div class="text-center" v-if="!order.abholbereit"><img src="@/assets/icons/loader.gif"></div>-->
                  <div v-if="!order.abholbereit" class="mt-2" style="opacity: 0.8">Der Status
                    aktualisiert automatisch
                  </div>
                </div>
              </div>

              <div v-else>
                <h3 v-if="showVorbestellung && !containsTicket()">Vorbestellung für
                  {{ order.pickupDate.utc | sdd }} Uhr</h3>
                <!--                    <span v-if="showAbholbereit">Jetzt Abholbereit</span>-->
                <div v-if="showBereitsAbgeholt">Abgeholt um {{ displayAbgeholtAm }}} Uhr</div>
                <div class="mt-2"><b>Bestell-Nr: #{{ order.orderNumber }}</b></div>
                <div v-if="order.userInfo && order.userInfo.name"><b>Name: {{ order.userInfo.name }}</b>
                </div>
                <div v-if="displayZahlungsart">Zahlung: {{ displayZahlungsart }}</div>
                <div v-if="containsTicket() && order.userInfo" class="pt-2">
                  Du erhälst die Tickets in wenigen Sekunden in deinem Email-Postfach
                  {{ order.userInfo.email }}
                </div>
                <div class="spacer-25"></div>
              </div>

            </div>
            <div v-if="order.usecase === 'delivery'">
              <h3>Lieferung für {{ order.deliveryDate.utc | weekDayMonth }}, ca. {{
                  order.deliveryDate.utc |
                    uhrzeit
                }} Uhr</h3>
              <h3>Summe: {{ order.paymentInfo.amount | price }}</h3>
              <h3>Bestell-Nr: {{ order.orderNumber }}</h3>
              <div class="pt-4">Lieferadresse: {{ order.deliveryAddress | displayDeliveryAddressSingleLine }}</div>
            </div>


            <!--                    <div><span v-if="showConfirmed">Bestätigter</span> {{displayTermin}}:</div>-->
            <!--                    <strong>{{displayZieltermin}} Uhr</strong>-->

            <div v-if="order.usecase === 'takeAway' && !containsTicket()">
              <div>Abholort: {{ $store.state.staticDisplayAbholung }}
                <!--                            der Filiale {{order.pickupStore.strasse}}, {{order.pickupStore.plz}}-->
                <!--                            {{order.pickupStore.ort}}-->
              </div>
              <!--                        <div v-if="order.pickupStore.telefon">-->
              <!--                            <v-btn class="mt-3 btn-df accentBtn text-none" rounded icon-->
              <!--                                   @click.native.passive="call(order.pickupStore.telefon)"-->
              <!--                                   style="width: auto">-->
              <!--                                <v-icon left medium>mdi-phone</v-icon>-->
              <!--                                {{order.pickupStore.telefon}}-->
              <!--                            </v-btn>-->
              <!--                        </div>-->
            </div>

            <div class="spacer-15"></div>
          </div>

          <ItemDetails :order="order"></ItemDetails>

          <div class="mt-5" v-if="order.note && order.note.length > 0">
            <div>Hinweis: {{ order.note }}</div>
          </div>

          <!--                    <div><strong style="font-size: 1.4em">{{order.usecase | displayOrderUsecase}}</strong></div>-->
          <!--                    <div style="margin-bottom: 20px;">Für die Abholung benötigst du:</div>-->
          <!--                <div v-if="!showConfirmed">-->
          <!--                    <h2 class="blinkText">Warte auf Bestätigung</h2>-->
          <!--                    <div style="padding: 10px 25px">Die Bestätigung des Anbieters erhälst du hier und per E-Mail-->
          <!--                    </div>-->
          <!--                </div>-->
          <!--                <h2>Vielen Dank für Ihre Bestellung!</h2>-->

          <!--                <div style="margin: 15px 0" class="confirmed" v-if="displayZieltermin.length > 0">-->
          <!--                    <div><span v-if="showConfirmed">Bestätigter</span> {{displayTermin}}:</div>-->
          <!--                    <strong>{{displayZieltermin}} Uhr</strong>-->

          <!--                    <div><b>Name: {{order.userInfo.name}}</b></div>-->
          <!--                    <div><b>Bestellnummer: #{{order.orderNumber}}</b></div>-->

          <!--                    <div v-if="order.usecase === 'takeAway'">-->
          <!--                        <div class="spacer-25"></div>-->
          <!--                        <div>Abholung in {{$store.state.staticDisplayAbholung}}-->
          <!--&lt;!&ndash;                            {{order.pickupStore.strasse}}, {{order.pickupStore.plz}}&ndash;&gt;-->
          <!--&lt;!&ndash;                            {{order.pickupStore.ort}}&ndash;&gt;-->
          <!--                        </div>-->
          <!--                        <div v-if="order.pickupStore.telefon">-->
          <!--                            <v-btn class="mt-3 btn-df accentBtn text-none" rounded icon-->
          <!--                                   @click.native.passive="call(order.pickupStore.telefon)"-->
          <!--                                   style="width: auto">-->
          <!--                                <v-icon left medium>mdi-phone</v-icon>-->
          <!--                                {{order.pickupStore.telefon}}-->
          <!--                            </v-btn>-->
          <!--                        </div>-->
          <!--                    </div>-->
          <!--                    <div class="spacer-15"></div>-->
          <!--                </div>-->
        </div>


        <!--        :style="{'opacity': withPosApi && !order.sentToPos?'0.8':'1'}"-->
        <div class="pickupHint text-center"
             v-if="(order.usecase === 'tableOrdering' || order.usecase === 'inhouseMobilePayment')">

          <div v-if="$store.getters.selfServiceEnabled"
               style="color: yellow; background-color: black; opacity: 0.8"
               class="mt-4 pa-4 mb-4 hinweisBlink">
            {{ hh }}
          </div>
          <div v-else class="text-center pt-4 mb-4">
            <div class="icon icon--order-success svg" v-if="!withPosApi || order.sentToPos">
              <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
                <circle stroke="#50A92F" stroke-width="2" cx="36" cy="36" r="34" fill="none"/>
                <path fill-rule="evenodd" clip-rule="evenodd" fill="#50A92F"
                      d="M52.5 21.4c-.9-.6-2.1-.5-2.8.2l-20.7 20.2-4.7-5.1c-.8-.8-2.4-1.2-3.5-.5-1.1.9-1.2 2.3-.5 3.5 0 0 5.1 8.7 5.7 9.7s1.6 1.6 3 1.6c1.1 0 2-.6 2.9-1.6.7-.8 20.8-25.3 20.8-25.3.6-.7.6-2-.2-2.7z"></path>
              </svg>
            </div>
          </div>

          <div style="margin: 15px 0" class="confirmed">

            <!--            <div v-if="withPosApi && !order.sentToPos">-->
            <!--              &lt;!&ndash;              <WaitingForPos></WaitingForPos>&ndash;&gt;-->
            <!--              <div v-if="$store.state.orderArea"><b>Bestellung für {{ $store.state.orderArea }}</b></div>-->
            <!--              <div v-else>-->
            <!--                <div v-if="order.table"><b>Bestellung an Tisch {{ order.table }}</b></div>-->
            <!--              </div>-->

            <!--            </div>-->
            <div class="mb-2">
              <div v-if="$store.state.orderArea"><h3>Bestellung für {{ $store.state.orderArea }}</h3></div>
              <div v-else>
                <div v-if="$store.getters.selfServiceEnabled">
                  <h3 v-if="order.table">Tisch {{ order.table }}</h3>
                  <h4>Summe: {{ order.paymentInfo.amount | price }}</h4>
                  <h4 v-if="computedPickupTime && !containsTicket()" class="mt-2">Abholung am
                    {{ computedPickupTime | sdd }} Uhr</h4>
<!--                  <div v-if="isInZubereitung">(bestätigte Abholzeit)</div>-->
                  <h4 v-if="order.table">Bestell-Nr: {{ order.orderNumber }}</h4>
                  <h4 v-else>Bestell-Nr: {{ order.orderNumber }}</h4>
                  <div class="text-center">
                    <div class="text-left d-inline-block mt-2">
                      <div><b>
                        <v-icon class="iconOk" medium>mdi-check-bold</v-icon>
                        &nbsp;Bestellung übermittelt</b>
                      </div>
                      <div v-if="hasGetraenke()"><b>
                        <v-icon
                          v-if="order.getraenkeAbholbereit"
                          class="iconOk" medium>mdi-check-bold
                        </v-icon>
                        <v-icon v-else class="iconNotOk" medium>mdi-close-thick</v-icon>&nbsp;
                        Getränke abholbereit</b>
                      </div>
                      <div v-if="hasSpeisen()"><b>
                        <v-icon
                          v-if="order.abholbereit"
                          class="iconOk" medium>mdi-check-bold
                        </v-icon>
                        <v-icon v-else class="iconNotOk" medium>mdi-close-thick</v-icon>&nbsp;
                        Speisen abholbereit</b>
                      </div>

                    </div>
                    <!--                                        <div class="text-center" v-if="!order.abholbereit"><img-->
                    <!--                                                src="@/assets/icons/loader.gif"></div>-->
                    <div v-if="!order.abholbereit" class="mt-2" style="opacity: 0.8">Der Status
                      aktualisiert automatisch
                    </div>
                  </div>
                </div>
                <div v-else>
                  <h3 v-if="order.table">Tisch {{ order.table }}</h3>
                  <h4 v-if="order.table">Bestell-Nr: {{ order.orderNumber }}</h4>
                  <h3 v-else>Bestell-Nr: {{ order.orderNumber }}</h3>
                  <h4>Summe: {{ order.paymentInfo.amount | price }}</h4>
                  <div class="mt-4"><b>
                    <v-icon class="iconOk" medium>mdi-check-bold</v-icon>&nbsp;Bestellung
                    übermittelt</b></div>
                  <div class="mt-2" v-if="order.table"><b>Wir servieren deine Bestellung an deinen
                    Tisch</b></div>
                  <div class="mt-2" v-else><b>Bestellung wird zubereitet</b></div>
                </div>
              </div>

            </div>

            <!--                    <span v-if="showAbholbereit">Jetzt Abholbereit</span>-->

            <!--                    <div><span v-if="showConfirmed">Bestätigter</span> {{displayTermin}}:</div>-->
            <!--                    <strong>{{displayZieltermin}} Uhr</strong>-->

            <!--                        <div v-if="$store.getters.selfServiceEnabled">-->
            <!--                            <div style="color: yellow; background-color: black; opacity: 0.8" class="mt-4 pa-4 mb-5">-->
            <!--                                HINWEIS: Die Bezahlung erfolgt immer vorab, entweder bei Abholung oder bei einer-->
            <!--                                Servicekraft-->
            <!--                            </div>-->
            <!--                        </div>-->
            <div v-if="order.userInfo && order.userInfo.name"><b>Name: {{ order.userInfo.name }}</b></div>
            <div v-if="displayZahlungsart">Zahlung: {{ displayZahlungsart }}</div>

            <div class="spacer-15"></div>
            <div v-if="enableAllReady && !hideAllReadyBtn && !order.allReady">
              <v-btn class="btn-mini" @click.native.passive="clickFertig">Wir sind fertig
                <v-icon right>mdi-send</v-icon>
              </v-btn>
              <div class="spacer-15"></div>
            </div>
          </div>

          <ItemDetails :order="order"></ItemDetails>

          <div class="mt-5" v-if="order.note && order.note.length > 0">
            <div>Hinweis: {{ order.note }}</div>
          </div>

        </div>
      </div>

      <div class="text-center pa-4">
        <div class="d-inline-block">
          <div class="mt-3 mb-3" v-if="order.invoiceUrl">
            <v-btn class="btn-mini" block rounded @click="$ebus.$emit('gotoWebsite',order.invoiceUrl)">
              Rechnung öffnen
              <v-icon right medium>
                mdi-open-in-new
              </v-icon>
            </v-btn>
          </div>
        </div>
      </div>


      <div class="pt-7 pb-7 text-center" v-if="!$store.getters.inhouse">
        <h4>Teile die App jetzt mit deinen Freunden!</h4>
        <v-icon x-large class="mt-5 myAccent pointer"
                @click.native.passive="$ebus.$emit('shareApp')"
        >mdi-share-variant
        </v-icon>
      </div>

      <!--            eof not storno and pickupHint -->

      <h2 class="text-center mt-8">Details</h2>

      <div class="metaBox text-center">
        <div class="d-inline-block text-left">
          <table class="maxw myMeta">
            <!--                    <tr>-->
            <!--                        <td>Bestellnummer:</td>-->
            <!--                        <td>#{{order.orderNumber}}</td>-->
            <!--                    </tr>-->
            <!--                    <tr>-->
            <!--                        <td>Name:</td>-->
            <!--                        <td>{{order.userInfo.name}}</td>-->
            <!--                    </tr>-->
            <tr>
              <td style="width: 15%;">Bestelldatum:</td>
              <td>{{ order.createdAt | dateToString }} Uhr</td>
            </tr>
            <tr>
              <td>Gesamtsumme:</td>
              <td>{{ order.paymentInfo.amount | price }}</td>
            </tr>
            <tr v-if="!containsTicket()">
              <td>Bestell-Typ:</td>
              <td>{{ order.usecase | displayOrderUsecase }}</td>
            </tr>
            <!--                    <tr>-->
            <!--                        <td>Bestellnummer:</td>-->
            <!--                        <td>{{order.uniqueOrderId}}</td>-->
            <!--                    </tr>-->
            <tr>
              <td>Zahlung:</td>
              <td>{{ displayZahlungsart }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="spacer-15"></div>

      <!--            <h2>Historie deiner Bestellung</h2>-->

      <!--            <v-timeline-->
      <!--                    align-top-->
      <!--                    dense-->
      <!--            >-->
      <!--                <v-timeline-item-->
      <!--                        :color="item.createdAt > 0 ? '#0A0A0A' : '#CCCCCC'"-->
      <!--                        v-for="item in historyStates"-->
      <!--                        :icon="item.createdAt > 0 ? 'mdi-check': null"-->
      <!--                >-->
      <!--                    <v-layout pt-3>-->
      <!--                        <v-flex xs5>-->
      <!--                            <div class="baseState" :class="{finished: item.createdAt > 0}">{{item.state}}</div>-->
      <!--                        </v-flex>-->
      <!--                        <v-flex>-->
      <!--                            <div>{{item.createdAt | dateToString}} <span v-if="item.createdAt">Uhr</span></div>-->
      <!--                            &lt;!&ndash;                            <div class="caption">Mobile App</div>&ndash;&gt;-->
      <!--                        </v-flex>-->
      <!--                    </v-layout>-->
      <!--                </v-timeline-item>-->
      <!--            </v-timeline>-->

      <div style="margin: 10px; padding: 15px 16px" class="text-center">
        <h3 v-if="order.capturedAt">Bezahlt am {{ order.capturedAt | dateToString }}</h3>
        <!--        <div v-else>-->
        <!--          <h3 if="order.checkoutId && order.authCompletedAt">Bezahlt am {{ order.authCompletedAt | dateToString }}</h3>-->
        <!--        </div>-->
        <h3 v-if="order.state === 'Rejected'">Ablehnungsgrund: {{ displayRejectReason }}</h3>
      </div>


      <div class="spacer-15"></div>

      <div class="text-center">
        <!--                <v-btn-->
        <!--                        class="mr-2 okBtn btn-df" rounded-->
        <!--                        @click.native.passive="refresh"-->
        <!--                >-->
        <!--                    <v-icon>mdi-refresh</v-icon>-->
        <!--                    Status aktualsieren-->
        <!--                </v-btn>-->
        &nbsp;&nbsp;<v-btn
        class="okBtn btn-df" rounded
        @click.native.passive="gotoAllOrders"
      >
        Alle Bestellungen
      </v-btn>
      </div>


      <div class="spacer-25"></div>

      <div class="text-center">
        <v-btn
          class="btn-df okBtn" rounded
          @click.native.passive=" $ebus.$emit('gotoStart')"
        >
          <!--                    onclick="window.history.back()"-->
          Zurück
        </v-btn>
      </div>

      <div class="spacer-25"></div>

      <!--            <qsignal class="hide-md"></qsignal>-->


    </v-container>

    <div v-if="ready">
      <div class="yellowHinweis showOk" v-if="showOk">
        <div class="superCenter">
          <div class="text-center">
            <h2>Speisen Abholbereit!</h2>
            <div class="pa-6" style="font-size: 1.4em;" v-if="order.table">Bestell-Nr. {{ order.orderNumber }}</div>
            <div class="pa-6" style="font-size: 1.4em;" v-else>Bestell-Nr. {{ order.orderNumber }}</div>
            <div class="mt-6 ok pointer" @click.passive="ok">
              >> OK <<
            </div>
          </div>
        </div>
      </div>

      <div class="yellowHinweis showOk" v-if="showGetraenkeOk">
        <div class="superCenter">
          <div class="text-center">
            <h2>Getränke Abholbereit!</h2>
            <div class="pa-6" style="font-size: 1.4em;" v-if="order.table">Bestell-Nr. {{ order.orderNumber }}</div>
            <div class="pa-6" style="font-size: 1.4em;" v-else>Bestell-Nr. {{ order.orderNumber }}</div>
            <div class="mt-6 ok pointer" @click.passive="ok">
              >> OK <<
            </div>
          </div>
        </div>
      </div>

      <div v-if="$store.state.enableSelfServiceExtras">
        <audio id="a-order" loop>
          <source id="s-order" src="takeawayOrder2x.mp3" type="audio/mpeg">
        </audio>
        <audio id="a-drinks" loop>
          <source id="s-drinks" src="takeawayDrinks2x.mp3" type="audio/mpeg">
        </audio>
      </div>

    </div><!-- eof ready-->

  </div>
</template>

<script>
import store from '@/store/store'
import {ebus} from '@/vendor/ebus';
import * as xhr from '@/api/xhr.js'
import * as util from '@/vendor/util'
import * as qconst from '@/vendor/qconstants';
import ItemDetails from "@/components/ItemDetails";
import {notificationUtil} from '@/notifications/notificationUtil'
import WaitingForPos from "@/components/WaitingForPos";
import {itemsContainsTicket} from "@/vendor/itemUtil";
import {getGlobalValueOrZero, setGlobalKeyValue} from "@/util/globalState";

export default {
  components: {WaitingForPos, ItemDetails},
  data() {
    return {
      initialInit: true,
      waitingForAbholbereit: false,
      waitingForGetraenkeAbholbereit: false,
      isTakeawayForNow: false,

      withPosApi: qconst.withPosApi,
      enableAllReady: qconst.enableAllReady,
      hideAllReadyBtn: false,

      order: {},
      ready: false,
      historyStates: [],
      refresher: null,

      hh: 'Bitte lass diese Seite geöffnet, und stelle dein Handy auf laut!',
      // 'Falls notwendig, kannst du den QR-Code erneut einscannen',
      showOk: false,
      showGetraenkeOk: false,

      uniqueOrderId: '',
    }
  },
  watch: {
    order: {
      handler: function handler(newVal, oldVal) {
        console.log('watched change waitingForAbholbereit=' + !!this.waitingForAbholbereit);
        if (newVal) {
          if (this.waitingForAbholbereit) {
            if (newVal.abholbereit) {
              // this.waitingForGetraenkeAbholbereit = false;
              this.waitingForAbholbereit = false;
              this.showAbholbereit();
            }
          }
          if (this.waitingForGetraenkeAbholbereit) {
            if (newVal.getraenkeAbholbereit) {
              this.waitingForGetraenkeAbholbereit = false;
              this.showGetraenkeAbholbereit();
            }
          }
          this.updateIsTakeawayForNow();
        }
      },
      deep: true,
    }
  },
  computed: {
    computedPickupTime() {
      let initial = this.order.targetTime
      return initial;
    },
    computedDeliveryTime() {
      let initial = this.order.targetTime;
      return initial;
    },
    displayAbgeholtAm() {
      //TODO use a global property of order
      // if (this.order.history && this.order.usecase === qconst.usecase$takeAway) {
      //   for (let event of this.order.history) {
      //     if (event.state === qconst.orderState$Collected) {
      //       return this.$options.filters.uhrzeit(event.createdAt);
      //     }
      //   }
      // }
      return '';
    },

    showVorbestellung() {
      if (this.isKilled()) {
        return false;
      }

      return this.order.usecase === qconst.usecase$takeAway && !this.order.kommissioniert;
    },

    // showAbholbereit() {
    //     if (this.isKilled()
    //         || this.order.state === qconst.orderState$Collected
    //     ) {
    //         return false;
    //     }
    //     return this.order.kommissioniert;
    // },

    showBereitsAbgeholt() {
      if (this.isKilled()
      ) {
        return false;
      }

      return this.order.usecase === qconst.usecase$takeAway && this.order.state === qconst.orderState$Collected;
    },


    displayRejectReason() {
      if (this.order && this.order.history) {
        for (let h of this.order.history) {
          if (h.state === 'Rejected' && h.reason) {
            return h.reason;
          }
        }
      }
      return '';
    },

    // displayZieltermin() {
    //     if (this.order) {
    //         // if (this.order.displayTargetDate) {
    //         //     return this.order.displayTargetDate;
    //         // }
    //         let date = util.calculateZieltermin(this.order);
    //         // let date = new Date();
    //         return util.shortDateDisplay(date, false, true);
    //     }
    //     return '';
    // },

    // displayTermin() {
    //     if (this.order.usecase) {
    //         if (this.order.usecase === 'delivery') {
    //             return 'Lieferzeitpunkt'
    //         }
    //         if (this.order.usecase === 'takeAway' || this.order.usecase === 'selfService') {
    //             return 'Abholzeitpunkt'
    //         }
    //     }
    //     return ''
    // },

    displayZahlungsart() {
      // if (this.order.onlinePay) {
      let psp = '';
      try {
        psp = this.order.psp.toLowerCase();
      } catch (e) {

      }
      // this.$options.filters.camelCase(this.order.psp);
      if (psp === 'credit' || psp === 'stripe') {
        psp = 'Girocard/Debitkarte oder Kreditkarte'
      } else if (psp === 'wallet') {
        psp = 'Apple/Google Pay'
      } else if (psp === 'googlewallet') {
        psp = 'Google Pay'
      } else if (psp === 'applewallet') {
        psp = 'Apple Pay'
      } else if (psp === 'customercard') {
        psp = 'Kundenkarte'
      } else if (psp === 'vorkasse') {
        psp = 'Vorkasse'
      } else if (psp === 'beiabholung') {
        psp = 'Bei Abholung'
      } else if (psp === 'beilieferung') {
        psp = 'Bei Lieferung'
      } else if (psp === 'waiter') {
        psp = 'Beim Kellner'
      } else if (psp === 'paypal') {
        psp = 'PayPal'
      }
      return psp;
      // }
      // return 'Barzahlung';
    },
  },

  created() {
    ebus.$on('detailReady', (params) => {

      ebus.$emit('startKeepAwake');
      this.updateIsTakeawayForNow();

      try {
        if (util.isKilled(this.order)) {
          return;
        }
        if (
          // store.getters.selfServiceEnabled &&
          (this.order.usecase !== qconst.usecase$delivery) &&
          util.orderHasFoods(this.order.orderData) &&
          this.order.requiresPickupNotification &&
          !this.$ls.get(this.getPickupKey())
          // !this.order.abholbereit
        ) {
          // if (this.order.pickupDate.utc - Date.now() > (5 * 60 * 1000 * -1)) {
          this.waitingForAbholbereit = true;
          // }
        }
        if (
          // store.getters.selfServiceEnabled &&
          (this.order.usecase !== qconst.usecase$delivery
          ) &&
          util.orderHasDrinks(this.order.orderData) &&
          this.order.requiresPickupNotification &&
          !this.$ls.get(this.getPickupKeyDrinks())
          // !this.order.getraenkeAbholbereit
          // && !this.order.abholbereit
        ) {
          this.waitingForGetraenkeAbholbereit = true;
        }
      } catch (e) {
        console.log('error in detailReady: ' + e.message);
      }

      if (this.initialInit) {
        this.initialInit = false;
        this.setupAbholDialog();
      }
    });

    ebus.$on('lastOrdersUpdated', () => {
      // this.ready = false;
      // setTimeout(() => {
      //     this.$nextTick(() => {
      this.init();
      //     });
      // }, 50);
    });

    ebus.$on('allReadyUpdated', () => {
      this.hideAllReadyBtn = true;
    });

    ebus.$on('cb-confirmAllready', (yesOrNo) => {
      if (yesOrNo === 'yes') {
        ebus.$emit('doConfirmAllReady', '' + this.order.table);
      }
    });

    // ebus.$on('cb-wantsAbholnotify', (yesOrNo) => {
    //   if (yesOrNo === 'yes') {
    //     this.getPermission();
    //   }
    // });

    ebus.$on('orderUpdated', () => {
      // this.ready = false;
      // setTimeout(() => {
      this.init();
      // }, 200);
    });
  },

  beforeMount() {
    this.uniqueOrderId = this.$route.params.uniqueOrderId;
  },

  mounted() {
    if (this.$route.params.uniqueOrderId) {
      this.uniqueOrderId = this.$route.params.uniqueOrderId;
    }
    this.initRefresher();

    ebus.$emit('startKeepAwake');
    this.initialInit = true;
    setTimeout(() => {
      store.commit('showLoading', false);
    }, 400);
    // util.jumpToTop();
    // store.commit('currentRoute', 'lastOrders');
    setTimeout(() => {
      this.loadSingleOrder(this.uniqueOrderId);
      // ebus.$emit('loadLastOrders', {uniqueOrderId: '' + this.uniqueOrderId});
    }, 2500);
    if (store.state.lastOrders.length === 0) {
      // ebus.$emit('loadLastOrders', {uniqueOrderId: '' + this.uniqueOrderId});
    } else {
      this.init()
    }
  },

  // activated() {
  //     ebus.$emit('startKeepAwake');
  //     this.initialInit = true;
  //     setTimeout(() => {
  //         store.commit('showLoading', false);
  //     }, 400);
  //     // util.jumpToTop();
  //     // store.commit('currentRoute', 'lastOrders');
  //     if (store.state.lastOrders.length === 0) {
  //         ebus.$emit('loadLastOrders', {uniqueOrderId: '' + this.uniqueOrderId});
  //     } else {
  //         this.init()
  //     }
  //
  //     this.initRefresher();
  //
  // },


  destroyed() {
    this.clearRefresher();
    util.clearEvents([
      'detailReady',
      'lastOrdersUpdated',
      'allReadyUpdated',
      'cb-confirmAllready',
      // 'cb-wantsAbholnotify',
      'orderUpdated',
    ]);
    this.initialInit = true;
    this.waitingForAbholbereit = false;
    this.waitingForGetraenkeAbholbereit = false;
    this.order.stornoAmounts = [];
    let oid = '' + this.order.uniqueOrderId;
    console.log('util.isTakeawayForNow(this.order) in deactivated = ' + !!util.isTakeawayForNow(this.order));
    if (//store.getters.selfServiceEnabled
      this.order.requiresPickupNotification
      && !this.order.abholbereit
      && !util.isKilled(this.order)
      && (this.order.usecase === qconst.usecase$tableOrdering
        // || util.isTakeawayForNow(this.order)
      )
      && oid !== 'undefined'
      && !this.containsTicket()
    ) {

      ebus.$emit('showInfo', {
        title: 'Bitte bleibe auf dem Bestellstatus!',
        text: 'Der Status der Abholbereitschaft wird dir hier angezeigt und aktualisiert sich automatisch'
      });
      // setTimeout(() => {
      //     this.$router.replace({name: 'Bestellung', params: {uniqueOrderId: oid}});
      // }, 2000);
    }
  },

  methods: {
    getPickupKeyDrinks() {
      return 'pickupNotificationOnceForDrinks' + this.order.uniqueOrderId
    },
    getPickupKey() {
      return 'pickupNotificationOnceFor' + this.order.uniqueOrderId
    },
    hasSpeisen() {
      return util.orderHasFoods(this.order.orderData);
    },
    hasGetraenke() {
      return util.orderHasDrinks(this.order.orderData);
    },
    async loadSingleOrder(uniqueOrderId) {
      if (!uniqueOrderId) {
        return;
      }
      let msg = {
        action: qconst.action$LoadDocs,
        collectionName: 'orders',
        query: {
          uniqueOrderId: uniqueOrderId,
        }
      };
      await xhr.xhrSend(true, msg, (data) => {
        if (data && data.ok && data.docs && Array.isArray(data.docs)) {
          let docs = data.docs;
          if (docs.length > 0) {
            let o = docs[0];
            this.order = o;
            store.commit('updateOrder', util.cloneMe(o));
            console.log('order updated by loadSingleOrder for ' + uniqueOrderId);
          }
        }
      }, (err) => {
        console.log('error in loadSingleOrder: ' + err, err);
      });
    },

    ok() {
      this.showOk = false;
      this.showGetraenkeOk = false;
      notificationUtil.stop();
    },

    containsTicket() {
      return itemsContainsTicket(this.order.orderData);
    },

    setupAbholDialog() {
      if (this.containsTicket()) {
        return;
      }
      if (store.getters.selfServiceEnabled &&
        (this.order.usecase === qconst.usecase$takeAway || this.order.usecase === qconst.usecase$tableOrdering) &&
        !util.isKilled(this.order) &&
        !this.order.abholbereit
      ) {
        this.thankYou();
      }
    },

    thankYou() {
      let now = Date.now();
      let easer = this.$ls.get('takeawayNotificationQuestionEaser') || 0;
      if (!easer || now - parseInt(easer) > 15 * 60 * 1000) {
        this.$ls.set('takeawayNotificationQuestionEaser', now);
      } else {
        //eased
        ebus.$emit('cb-wantsAbholnotify', 'yes');
        return;
      }

      setTimeout(() => {
        // if (!notificationUtil.isGranted()) {
        ebus.$emit('showQuestion', {
          quest: 'Danke für deine Bestellung! ' +
            // 'Bitte lass diese Seite geöffnet, und stelle dein Handy auf laut! ' +
            //Du kannst die Abholbereitschaft auf dieser Seite beobachten.
            'Möchtest zur Abholung benachrichtigt werden?',
          text: 'Deine persönliche Bestell-Historie findest du auf der Startseite unter dem Punkt "Bestellungen".',
          // quest: 'Bitte lass diese Seite geöffnet, und stelle dein Handy auf laut! ' +
          //     'Möchtest du zudem benachrichtigt werden?',
          // text: 'Du kannst den QR-Code jederzeit erneut einscannen, um den Status zu sehen.',
          yesLabel: 'Ja erlauben',
          noLabel: 'Nein danke',
          // yesAction: null,
          cb: 'cb-wantsAbholnotify'
        });
        // }
      }, 2000);
    },

    // debugNotification() {
    //     let bitte = 'Bitte teile uns bei der Abholung die Tischnummer mit: Tisch ' + this.order.table;
    //     if (this.order.usecase === qconst.usecase$takeAway) {
    //         bitte = 'Bitte teile uns bei der Abholung deine Summe und die deine Bestellnummer mit.';
    //     }
    //     notificationUtil.showNotification('Deine Bestellung ist abholbereit!',
    //         'Summe: ' + this.$options.filters.price(this.order.paymentInfo.amount)
    //         + ' Bestell-Nr. ' + this.order.orderNumber + '. ' + bitte,
    //         false
    //     );
    // },
    // debugNow() {
    //     alert('isTakeawayForNow = ' + !!util.isTakeawayForNow(this.order));
    // },
    updateIsTakeawayForNow() {
      if (this.containsTicket()) {
        return;
      }

      let o = this.order;
      if (o && o.usecase) {
        this.isTakeawayForNow = (o.usecase === qconst.usecase$tableOrdering) && util.isTakeawayForNow(o);
        // this.isTakeawayForNow = (o.usecase === qconst.usecase$takeAway) && util.isTakeawayForNow(o);
        console.log('updated isTakeawayForNow=' + !!this.isTakeawayForNow);
      }
    },
    getPermission() {
      ebus.$emit('lazyRequestPush', true);
      // notificationUtil.requestPremission();
    },
    showAbholbereit() {
      console.log('showAbholbereit...');
      let exp = 2 * 30 * 24 * 60 * 60 * 1000;//expiry 2 Months
      this.$ls.set(this.getPickupKey(), true, exp);
      this.showOk = true;
      if (!util.isKilled(this.order)) {
        // && this.order.abholbereit) {
        let bitte = '';
        // 'Bitte teile uns bei der Abholung die Tischnummer mit: Tisch ' + this.order.table;
        // if (this.order.usecase === qconst.usecase$takeAway) {
        //     bitte = 'Bitte teile uns bei der Abholung deine Summe und die deine Bestellnummer mit.';
        // }
        notificationUtil.showNotification('Deine Bestellung ist abholbereit!',
          'Summe: ' + this.$options.filters.price(this.order.paymentInfo.amount)
          + ' Bestell-Nr. ' + this.order.orderNumber + '. ' + bitte,
          true
        );
      }
    },
    showGetraenkeAbholbereit() {
      console.log('showGetraenkeAbholbereit...');
      let exp = 2 * 30 * 24 * 60 * 60 * 1000;//expiry 2 Months
      this.$ls.set(this.getPickupKeyDrinks(), true, exp);
      this.showGetraenkeOk = true;
      if (!util.isKilled(this.order)) {
        // && this.order.getraenkeAbholbereit && !this.order.abholbereit) {
        let bitte = '';
        // 'Bitte teile uns bei der Abholung die Tischnummer mit: Tisch ' + this.order.table;
        // if (this.order.usecase === qconst.usecase$takeAway) {
        //     bitte = 'Bitte teile uns bei der Abholung deine Summe und die deine Bestellnummer mit.';
        // }
        notificationUtil.showGetraenkeNotification('Deine Getränke sind abholbereit!',
          'Summe: ' + this.$options.filters.price(this.order.paymentInfo.amount)
          + ' Bestell-Nr. ' + this.order.orderNumber + '. ' + bitte,
          true
        );
      }
    },
    isSentToPos() {
      let sentToPos = false;
      try {
        sentToPos = !!this.order.sentToPos;
      } catch (e) {

      }
      return sentToPos;
    },
    clickFertig() {
      ebus.$emit('showAlleFertigDialog');
    },
    initRefresher() {
      this.clearRefresher();
      this.refresher = setInterval(() => {
        this.loadSingleOrder(this.uniqueOrderId);
        // ebus.$emit('loadLastOrders', {uniqueOrderId: '' + this.uniqueOrderId});
        // this.ready = false;
        // setTimeout(() => {
        //     this.init();
        // }, 200);
        // if (this.isSentToPos()) {
        //     this.clearRefresher();
        // }
        if (
          (!this.hasSpeisen || this.order.abholbereit) &&
          (!this.hasGetraenke || this.order.getraenkeAbholbereit)
        ) {
          this.clearRefresher();
        }

        this.updateIsTakeawayForNow();

      }, 15 * 1000);
      this.updateIsTakeawayForNow();
    },

    clearRefresher() {
      try {
        util.clearTheInterval(this.refresher);
      } catch (e) {

      }
      this.refresher = null;
    },

    isKilled() {
      return !this.ready
        || util.isKilled(this.order);
    },
    // isAbholterminErreicht() {
    //     return Date.now() - this.order.pickupDate.utc > 0;
    // },
    init() {
      let lastOrders = store.state.lastOrders;
      console.log('??? number of lastOrders: ' + lastOrders.length);

      let found = false;
      this.uniqueOrderId = this.$route.params.uniqueOrderId;
      for (let o of lastOrders) {
        if (o.uniqueOrderId === this.uniqueOrderId) {
          found = true;
          console.log('??? uniqueOrderId found!!!');
          if (o.directPay && o.psp && !o.authCompleted) {
            this.$router.replace({name: 'Home'});
            return;
          }

          // if (this.order) {
          // let oc = util.cloneMe(this.order);
          this.order = o;
          // }
          // this.order.getraenkeAbholbereit = false;
          // this.order.abholbereit = false;
          // if (util.isEmptyObject(oc)) {
          //   this.ready = false;
          //   this.order = o;
          setTimeout(() => {
            this.ready = true;
            ebus.$emit('detailReady');
          }, 50);
          // } else {
          //   this.order.stornoAmounts = [];
          //   Object.assign(this.order, o);
          //   this.ready = true;
          //   ebus.$emit('detailReady');
          // }
          // this.updateHistoryStates();
          break;
        }
      }
      if (!found) {
        // console.log('Error: Bestellung ' + this.$route.params.uniqueOrderId + ' wurde nicht gefunden');

        //retry
        // ebus.$emit('loadLastOrders');
        setTimeout(() => {
          this.init();
        }, 2000);
        //     ebus.$emit('info', 'Bestellung ' + this.$route.params.uniqueOrderId + 'wurde nicht gefunden');
        //     // ebus.$emit('gotoStart');
      }
      console.log('??? finished with re-init orderDetails');
    },

    call(telefon) {
      try {
        let t = telefon.trim();
        let phone = '+49';

        //replace all empty spaces
        t = t.replace(/ /g, '');

        //remove leading zero
        t = t.replace(/^0+/, '');

        //remove all /
        t = t.replace(/\//g, '');

        //remove all -
        t = t.replace(/-/g, '');

        phone = phone + t;
        console.log('call phone ' + phone);

        let win = window.open('tel:' + phone);
      } catch (e) {
        console.log('Error parsing telefon');
      }
    },

    refresh() {
      // store.commit('showLoading', true);
      // this.loadSingleOrder(this.uniqueOrderId);
      // // ebus.$emit('loadLastOrders', {uniqueOrderId: '' + this.uniqueOrderId});
      // setTimeout(() => {
      //   store.commit('showLoading', false);
      // }, 400);
    },

    gotoAllOrders() {
      this.$router.push({name: 'Bestellungen'});
    },

    // updateHistoryStates() {
    //     // historyStates
    //     // Submitted
    //     // Waiting
    //     // Confirmed
    //     // PreparingFood
    //     // ReadyForCollection / ReadyForDelivery
    //     // Delivering
    //     // Collected / Delivered
    //     let states = [
    //         {//index = 0
    //             state: 'Gesendet',
    //             createdAt: 0
    //         },
    //         // {//index = 1
    //         //     state: 'Warten auf Bestätigung',
    //         //     createdAt: new Date().getTime()
    //         // },
    //         {//index = 1
    //             state: 'Bestätigt',
    //             createdAt: 0
    //         },
    //     ];
    //     // if (this.order.usecase === 'takeAway') {
    //     //     states.push({
    //     //         //index = 2
    //     //         state: 'Abgeholt',
    //     //         createdAt: 0
    //     //     });
    //     // } else if (this.order.usecase === 'delivery') {
    //     //     states.push({
    //     //         //index = 2
    //     //         state: 'In Lieferung',
    //     //         createdAt: 0
    //     //     });
    //     //     states.push({
    //     //         //index = 3
    //     //         state: 'Geliefert',
    //     //         createdAt: 0
    //     //     });
    //     // }
    //
    //     //preselect the history
    //     for (let item of this.order.history) {
    //         if (item.state === 'New') {
    //             states[0].createdAt = item.createdAt;
    //         }
    //         if (item.state === 'Confirmed') {
    //             states[1].createdAt = item.createdAt;
    //         }
    //         // if (item.state === 'PreparingFood') {
    //         //     states[3].createdAt = item.createdAt;
    //         // }
    //         // if (item.state === 'ReadyForCollection' || item.state === 'ReadyForDelivery') {
    //         //     states[4].createdAt = item.createdAt;
    //         // }
    //         // if (item.state === 'Delivering') {
    //         //     states[2].createdAt = item.createdAt;
    //         // }
    //         // if (item.state === 'Collected') {
    //         //     states[2].createdAt = item.createdAt;
    //         // }
    //         // if (item.state === 'Delivered') {
    //         //     states[3].createdAt = item.createdAt;
    //         // }
    //
    //         if (item.state === 'Rejected') {
    //             states.push({
    //                 state: 'Abgelehnt',
    //                 createdAt: item.createdAt
    //             });
    //             //filter out createdAt 0
    //             states = states.filter(state => {
    //                 return state.createdAt > 0;
    //             });
    //             break;
    //         } else if (item.state === 'Cancelled') {
    //             states.push({
    //                 state: 'Abgebruchen',
    //                 createdAt: item.createdAt
    //             });
    //             //filter out createdAt 0
    //             states = states.filter(state => {
    //                 return state.createdAt > 0;
    //             });
    //             break;
    //         }
    //     }
    //
    //     this.historyStates = states;
    // },


  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/base.scss';
/*@import '@/styles/sharedStyles';*/

.showOk {
  position: fixed;
  z-index: 200;
  top: 20vh;
  padding: 50px 0;
  width: 100vw;
  min-height: 200px;
  opacity: 1;

  .ok {
    border-radius: $box-border-radius;
    padding: 20px 30px;
    background-color: rgba(white, 0.9);
    color: black;
    font-size: 1.5em;
  }
}

.iconOk {
  color: #0AC900;
}

i.v-icon ::v-deep .iconOk {
  color: #0AC900;
}

.iconNotOk {
  color: #FF3328;
}

i.v-icon ::v-deep .iconNotOk {
  color: #FF3328;
}

.confirmed {
  //color: $accent;
  font-size: 1.1em;
}

.theme--light.v-timeline:before {
  background-color: $accent;
  //background: rgba($accent-dark, 0.7);
}

.metaBox {
  //background-color: $color-darkblue;
  /*color: white;*/
  /*background-color: white;*/
  padding: 8px;
  //border-radius: $box-border-radius;
  /*border-radius: 25px;*/
}

.myMeta {
  td {
    padding: 6px;
  }

  td:first-child {
    padding-right: 15px;
  }
}

.finished {
  color: $accent;
}

.pickupHint {
  margin: 15px 16px;
  //background-color: white;
  border: 2px solid $accent;
  //border-left: 6px solid $accent;
  border-radius: $box-border-radius;
  padding: 8px;
  //@include material-shadow(1);

  /*margin: 25px 0 12px 0;*/
  /*padding: 2vw;*/

  .high {
    font-size: 1.1em;
  }
}

//////////////////////////
.icon--order-success svg path {
  -webkit-animation: checkmark 0.25s ease-in-out 0.7s backwards;
  animation: checkmark 0.25s ease-in-out 0.7s backwards
}

.icon--order-success svg circle {
  -webkit-animation: checkmark-circle 0.6s ease-in-out backwards;
  animation: checkmark-circle 0.6s ease-in-out backwards
}

.hinweisBlink {
  animation: hhBlink linear 0.4s infinite;
  font-size: 0.8em;
  border-radius: $box-border-radius;
}

@keyframes hhBlink {
  from {
    background-color: default;
  }
  50% {
    background-color: lighten(black, 25%);
  }
  to {
    background-color: default;
  }
}

</style>
